import useApi from 'hooks/useApi';
import useAuthToken from 'hooks/useAuthToken';
import { IStudent } from 'models/student';
import { useEffect, useMemo, useState } from 'react';
import redirectToAuth from 'utilities/redirectToAuth';
import { AxiosError } from 'axios';
import { BackendError } from 'models/backend-error';

const useTutorStudent = ({ studentId }: { studentId: string }): IStudent | null => {
  const [ student, setStudent ] = useState<IStudent | null>(null);

  const { getAuthToken, removeAuthToken } = useAuthToken();
  const authToken = useMemo<string | null>(() => getAuthToken() ?? null, [ getAuthToken ]);

  const api = useApi();

  useEffect(() => {
    if (authToken) {
      api.request<IStudent>({
        method: 'GET',
        url: `tutor/students/${studentId}`,
        headers: {
          authorization: `Bearer ${authToken}`,
        },
      }).then(({ data }) => {
        setStudent(data);
      }).catch((error: AxiosError<BackendError>) => {
        setStudent(null);

        if (error.response?.status === 401) {
          removeAuthToken();
          redirectToAuth();
        }
      });
    } else {
      redirectToAuth();
    }
  }, [ studentId, authToken ]);

  return student;
};

export default useTutorStudent;
